import type { CreateEntry } from "@roman/shared/types/CreateEntry";
import type { RoundDetails } from "@roman/shared/types/RoundDetails";

export type Tab = {
  type: "info" | "rule" | "prize";
  title: string;
};

export const TABS: Tab[] = [
  {
    type: "prize",
    title: "賞金額",
  },
  {
    type: "rule",
    title: "遊び方",
  },
  {
    type: "info",
    title: "注意事項",
  },
];

export type PlayerScoring = {
  name: string;
  score: number;
};

export const ALL_PLAYER_SCORE: PlayerScoring[] = [
  {
    name: "ゴール",
    score: 10,
  },
  {
    name: "アシスト",
    score: 6,
  },
  {
    name: "シュート",
    score: 1,
  },
  {
    name: "枠内シュート",
    score: 1,
  },
  {
    name: "クロス",
    score: 0.7,
  },
  {
    name: "決定機パス",
    score: 1,
  },
  {
    name: "正確なパス",
    score: 0.02,
  },
  {
    name: "被ファウル",
    score: 1,
  },
  {
    name: "ファウル",
    score: -0.5,
  },
  {
    name: "タックル成功",
    score: 1,
  },
  {
    name: "イエローカード",
    score: -1.5,
  },
  {
    name: "レッドカード",
    score: -3,
  },
];

export const NON_GK_SCORE: PlayerScoring[] = [
  {
    name: "インターセプト",
    score: 0.5,
  },
];

export const DEFENDER_SCORE: PlayerScoring[] = [
  {
    name: "クリーンシート",
    score: 3,
  },
];

export const GOAL_KEEPER_SCORE: PlayerScoring[] = [
  {
    name: "セーブ",
    score: 2,
  },
  {
    name: "失点",
    score: -2,
  },
  {
    name: "クリーンシート",
    score: 5,
  },
  {
    name: "勝利",
    score: 5,
  },
  {
    name: "PKセーブ",
    score: 3,
  },
];

type PrizeColorCodeType = {
  [key: string]: {
    foreground: string;
    background: string;
  };
};

export const PrizeColorCodes: PrizeColorCodeType = {
  "1": {
    foreground: "#E4AE00",
    background: "#FFF9E2",
  },
  "2": {
    foreground: "#9DA9AA",
    background: "#F0F4F5",
  },
  "3": {
    foreground: "#C79F80",
    background: "#F8F0EA",
  },
};

export const RoundDetailPlayButtonText = {
  Enter: "エントリーする",
  AddEntry: "追加エントリーする",
};

export const getEntryDetailType = (type: RoundDetails["type"]): CreateEntry["detail"]["type"] | null => {
  switch (type) {
    case "Round0001":
      return "0001";
    case "Round0002":
      return "0002";
    default:
      return null;
  }
};
